// @ts-strict

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ICampaignConfigFieldData } from '@app/core/models/core-models';
import { TranslateService } from '@ngx-translate/core';

export type CategoriesArrayCategory = {
  id: number;
  children: CategoriesArrayCategory[];
  checked: boolean;
  translated: string;
  quantity?: number;
};
export interface CategoriesArray {
  control_type: string;
  control_name: string;
  categories: CategoriesArrayCategory[];
}
@Component({
  selector: 'app-traffic-source-categories',
  templateUrl: './traffic-source-categories.component.html',
  styleUrls: ['./traffic-source-categories.component.scss']
})
export class TrafficSourceCategoriesComponent implements OnInit {
  @Input() categoriesValuesArray?: ICampaignConfigFieldData;
  @Input() isEditMode: boolean = false;
  @Input() submitted: boolean = false;
  @Output() checkedValues = new EventEmitter<number[]>();

  public checkedCategories: number[] = [];
  public categoriesArray: CategoriesArray = {
    control_type: 'checkbox_tree',
    control_name: 'category',
    categories: []
  };

  constructor(private readonly translate: TranslateService) {}

  ngOnInit(): void {
    if (this.categoriesValuesArray?.values) {
      this.categoriesArray = {
        ...this.categoriesArray,
        categories: this.prepareData(this.categoriesValuesArray.values as Record<string, string>[], this.categoriesValuesArray?.value)
      };
    }
  }

  getCheckedValues($event: number[]): void {
    this.checkedCategories = $event;
    this.checkedValues.emit($event);
  }

  prepareData(dataArray: Record<string, any>[], checkedValues: any[]): CategoriesArrayCategory[] {
    const checkedCategories = checkedValues;
    const preparedData = dataArray.map(el => {
      let subelements = el.children;
      let checkParentElement = false;
      if (subelements.length) {
        subelements = this.prepareData(subelements, checkedCategories);
        checkParentElement = this.checkIfAllSubelemntsAreChecked(subelements);
      }
      const singleElement = { id: el.id, children: [...subelements], checked: checkParentElement, translated: this.translate.instant('categories.' + el.id) };
      if (checkedCategories) {
        const elementToCheck = checkedCategories.find(el => el === singleElement.id);
        if (elementToCheck) {
          singleElement.checked = true;
        }
      }
      return singleElement;
    });
    return preparedData;
  }

  checkIfAllSubelemntsAreChecked(arrayOfSubelements: { checked: boolean }[]): boolean {
    const checkedSubelements: {
      checked: boolean;
    }[] = [];
    arrayOfSubelements.map(el => {
      if (el.checked === true) {
        checkedSubelements.push(el);
      }
    });
    return checkedSubelements.length === arrayOfSubelements.length ? true : false;
  }
}
